<div ngbDropdown class="document-context-menu" [container]="'body'" [autoClose]="true">
  <button
    type="button"
    class="context-menu-trigger"
    ngbDropdownToggle
    [attr.aria-expanded]="false"
    (click)="onMenuClick($event)"
    title="More actions">
    <custom-icon name="menuDots" [size]="20" viewBox="0 0 20 20" />
  </button>

  <div ngbDropdownMenu class="context-menu-dropdown">
    @if (canEdit()) {
      <button type="button" ngbDropdownItem class="context-menu-item" (click)="onRenameClick($event)">
        <custom-icon name="pen" [size]="16" viewBox="0 0 16 16" />
        <span>Rename</span>
      </button>
    }

    <button type="button" ngbDropdownItem class="context-menu-item" (click)="onDuplicateClick($event)">
      <custom-icon name="copy" [size]="16" viewBox="0 0 16 16" />
      <span>Duplicate</span>
    </button>

    @if (isOwner() && canMove()) {
      <button ngbDropdownItem class="context-menu-item" (click)="onMoveClick($event)">
        <custom-icon name="folder" [size]="16" viewBox="0 0 20 20" />
        <span>Move to folder</span>
      </button>
    }

    @if (isOwner() && !isTemporaryUser()) {
      <button type="button" ngbDropdownItem class="context-menu-item" (click)="onShareClick($event)">
        <custom-icon name="forward" [size]="16" viewBox="0 0 16 16" />
        <span>Share</span>
      </button>
    }

    <div ngbDropdown class="export-submenu" placement="right-top" [container]="'body'">
      <button type="button" ngbDropdownToggle class="context-menu-item" (click)="onMenuClick($event)">
        <custom-icon name="inboxIn" [size]="16" viewBox="0 0 16 16" />
        <span>Export</span>
        <custom-icon name="chevronRight" [size]="16" viewBox="0 0 16 16" class="submenu-arrow" />
      </button>

      <div ngbDropdownMenu class="context-menu-dropdown export-submenu-dropdown">
        <button type="button" ngbDropdownItem class="context-menu-item" (click)="onExportClick('markdown')">
          <span>Copy as Markdown</span>
        </button>
        <button type="button" ngbDropdownItem class="context-menu-item" (click)="onExportClick('document')">
          <span>Copy formatted text</span>
        </button>
        <div class="divider-horizontal"></div>
        <button type="button" ngbDropdownItem class="context-menu-item" (click)="onExportClick('pdf')">
          <span>Export as PDF</span>
        </button>
        <button type="button" ngbDropdownItem class="context-menu-item" (click)="onExportClick('docx')">
          <span>Export as DOCX</span>
        </button>
      </div>
    </div>

    @if (isOwner() && !isTemporaryUser()) {
      <div class="divider-horizontal"></div>
    }

    @if (isOwner()) {
      <button type="button" ngbDropdownItem class="context-menu-item text-danger" (click)="onDeleteClick($event)">
        <custom-icon name="trashBin" [size]="16" viewBox="0 0 16 16" />
        <span>Delete</span>
      </button>
    }
  </div>
</div>
